import React, { useState, useEffect, useRef } from "react";
import AddItemButton from "./AddItemButton";
import ClearAllButton from "./ClearAllButton";
import ExportPdfButton from "./ExportPdfButton";
import { ViewModeSelect } from "./ViewModeSelect";
import { SizeSelect, ItemSizeType } from "./SizeSelect";

interface StickyActionProps {
    onAdd: () => void;
    currentCount: number;
    maxItems: number;
    itemName: string;
    viewMode: string;
    setViewMode: (mode: string) => void;
    itemSize: ItemSizeType;
    setItemSize: (size: ItemSizeType) => void;
    onClear: () => void;
    confirmMessage: string;
}

const StickyAction = ({
    onAdd,
    currentCount,
    maxItems,
    itemName,
    viewMode,
    setViewMode,
    itemSize,
    setItemSize,
    onClear,
    confirmMessage,
}: StickyActionProps) => {
    const [isSticky, setIsSticky] = useState(false);
    const headerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (headerRef.current) {
                const rect = headerRef.current.getBoundingClientRect();
                // Check if the element is at the top of the viewport (sticking)
                // We use 1px tolerance to account for sub-pixel rendering
                setIsSticky(rect.top <= 1);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check on mount

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div
            ref={headerRef}
            className={`row mb-4 mb-md-5 sticky-top ${isSticky ? "sticky-active" : ""}`}
            style={{ zIndex: 1000 }}
        >
            <div className="col-12">
                <div
                    className="sticky-action-bar mx-auto mt-2"
                    style={{
                        backgroundColor: isSticky ? "rgba(255, 255, 255, 0.94)" : "transparent",
                        backdropFilter: isSticky ? "blur(12px)" : "none",
                        WebkitBackdropFilter: isSticky ? "blur(12px)" : "none",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        border: isSticky ? "2px solid #2b3034" : "none",
                        boxShadow: isSticky ? "0 8px 24px rgba(0, 0, 0, 0.1)" : "none",
                        borderRadius: "50px",
                        width: "fit-content",
                    }}
                >
                    <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                        <AddItemButton
                            onAdd={onAdd}
                            currentCount={currentCount}
                            maxItems={maxItems}
                            itemName={itemName}
                        />
                        <div className="d-none d-md-block">
                            <ViewModeSelect viewMode={viewMode} setViewMode={setViewMode} />
                        </div>
                        <SizeSelect itemSize={itemSize} setItemSize={setItemSize} />
                        <ExportPdfButton />
                        <ClearAllButton onClear={onClear} confirmMessage={confirmMessage} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StickyAction;
